module.exports = __webpack_public_path__ + "img/ageas.152727f0.png";